const state = {
    user: {
        id: null,
        name: null,
        email: null,
        group_id: null,
    }
}

export default state